import { useCallback, useDebugValue, useState } from 'react';
import { css } from 'styled-components';

export const slideAnimationCss = css`
  position: relative;
  overflow-x: hidden;

  @keyframes baseAnimation {
    0% {
      opacity: 0;
    }
    100% {
      opacity: 1;
    }
  }

  @keyframes slideLeft {
    0% {
      left: -100%;
    }
    100% {
      left: 0;
    }
  }

  @keyframes slideRight {
    0% {
      right: -100%;
    }
    100% {
      right: 0;
    }
  }

  &.slideFromLeft {
    animation: slideLeft 0.3s ease, baseAnimation 0.3s ease;
  }

  &.slideFromRight {
    animation: slideRight 0.3s ease, baseAnimation 0.3s ease;
  }
`;

interface HookReturnType {
    tabIndex: number;
    animationClass: string | undefined;
    navigateToPage(newPageNum: number): void;
    resetAnimation(): void;
}

function useAnimatedPaging(startingTabIndex?: number): HookReturnType {
    const [tabIndex, setTabIndex] = useState(startingTabIndex ?? 0);
    const [animationClass, setAnimationClass] = useState<string | undefined>();

    const navigateToPage = useCallback(
        (newPageNum: number) => {
            setTabIndex(curr => {
                if (newPageNum > curr) {
                    setAnimationClass('slideFromRight');
                }
                else if (curr > newPageNum) {
                    setAnimationClass('slideFromLeft');
                }

                return newPageNum;
            });
        },
        [],
    );

    const resetAnimation = useCallback(
        () => {
            setTabIndex(0);
            setAnimationClass(undefined);
        },
        [],
    );

    useDebugValue({ tabIndex });

    return { tabIndex, animationClass, navigateToPage, resetAnimation };
}

export default useAnimatedPaging;